import PageTitleComponent from "../../components/PageTitle";
import ReferralCommissionComponent from "../../components/Users/ReferralCommission";

export default function ReferralCommissionScreen(){
return <div>
    <PageTitleComponent title="Referral Commission" />
    <ReferralCommissionComponent/>
</div>
}